
export function AiSatisfactionAnswerExitViewConstructor(services) {

  let joint = services.joint;

  return joint.shapes.html.AbstractElementView.extend({
    isElementEditable: true,
    isElementDeletable: false,
    editElementModalController: 'editAiSatisfactionAnswerExitController',
    editElementModalTemplate: require('./edit-ai-satisfaction-answer-exit.modal.html'),

    angularTemplate: `
    <div layout="column">
      <span>{{elementData.label}} </span>
    </div>
      `,

    afterEditElement: function () {
      this.model.set('elementData', this.angularScope.elementData);
      const boxView = this.boxView();
      setTimeout(() => boxView.updateValidity());
    },

    boxView: function () {
      let parent = this.model.getAncestors()[0];
      return this.paper.findViewByModel(parent);
    }
  })
}
